import { Component } from '@angular/core';
import { ListAndDetailActionComponent } from '../list-and-detail-common-action/list-and-detail-common-action';
import { map } from 'rxjs';
import { NtapGlobalConstants, Util } from '@ntap/core';

@Component({
  selector: 'app-confirm-povrat-gradiva-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class ConfirmPovratFizickogObjektaActionComponent extends ListAndDetailActionComponent {
  protected override initDisabledObservable(): void {
    this.isDisabled$ = this.listViewProvider.selectedItems$.pipe(
      map((selectedItems) => {
        if (selectedItems.length <= 0) {
          return true;
        }

        const hasDifferentStatus = selectedItems.some((item: any) => {
          const mainType = item[NtapGlobalConstants.ATTR_$itemType];
          const statusValue =
            item[
              Util.getFullAttrName(mainType, 'status_dostave_fizickog_objekta')
            ] ||
            item[
              Util.getFullAttrName(mainType, 'status_dostave_jedinice_gradiva')
            ] ||
            item[
              Util.getFullAttrName(mainType, 'status_dostave_pojavnog_oblika')
            ];

          return statusValue !== 'ZA_VRACANJE';
        });

        return hasDifferentStatus;
      })
    );
  }
}
